import { Add } from "@material-ui/icons";
import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import NoFooterModal from "../Common/NoFooterModal";
import useForm from "../Common/FormComponent/useForm";
import FormComponent from "../Common/FormComponent/FormComponent";

const AddLanguageDialog = ({
  options = [],
  onSelect,
  title = "Add Language",
}) => {
  const [open, setOpen] = useState(false);
  const form = useForm({
    language: "en",
  });
  return (
    <>
      <Button onClick={() => setOpen(true)} endIcon={<Add />} color="error">
        {title}
      </Button>
      {open && (
        <NoFooterModal
          handleClose={() => setOpen(false)}
          header
          heading="Select language to add"
        >
          <Box display={"flex"} gap={1} alignItems={"center"}>
            {[
              {
                id: "language",
                type: "Radio",
                props: {
                  options,
                  color: "error",
                },
              },
            ].map((item) => (
              <FormComponent key={item.id} config={item} form={form} />
            ))}
          </Box>
          <Box mt={4} display={"flex"} justifyContent={"end"}>
            <Button
              color="error"
              variant="contained"
              onClick={() => {
                onSelect(form.values.language);
                setOpen(false);
              }}
            >
              Add
            </Button>
          </Box>
        </NoFooterModal>
      )}
    </>
  );
};

export default AddLanguageDialog;
